import axios from "axios";


const getConfig = async () => {
    const res = await fetch('/config.json');
    var config = await res.json();
    return config;
}
export const getRequest = (url, loaderText) => {
    return new Promise(async (resolve, reject) => {
        console.log(url);
        window.ToggleLoader(loaderText);
        axios({
            method: "get",
            url: `${localStorage.getItem("domain")}${url}`,
            headers: {
                "dataviztoken": localStorage.getItem("token"),
                "Authorization": `Bearer ${localStorage.getItem("jwt")}`

            }
        })
            .then((result) => {
                window.ToggleLoader();
                resolve(result);
            })
            .catch(function (err) {
                if (err?.response?.status === 401) {
                    window.sessionExpired();
                }
                window.ToggleLoader();
                reject(err)
            })
    })
}

export const postRequest = (url, data, loaderText) => {
    return new Promise(async (resolve, reject) => {
        console.log(url);
        window.ToggleLoader(loaderText);
        axios({
            method: "post",
            url: `${localStorage.getItem("domain")}${url}`,
            data: data,
            headers: {
                'Content-Type': 'application/json',
                "dataviztoken": localStorage.getItem("token"),
                "Authorization": `Bearer ${localStorage.getItem("jwt")}`
            }
        })
            .then((result) => {
                window.ToggleLoader();
                resolve(result);
            })
            .catch(function (err) {
                if (err?.response?.status === 401) {
                    window.sessionExpired();
                }
                window.ToggleLoader();
                reject(err)
            })
    })
}



export const readJsonFromPresignedUrl = async (url) => {
    try {
        console.log(url)
        const response = await axios.get(url);
        const json = response.data;
        return json;
    } catch (error) {
        console.error(error);
        window.sessionExpired();
        return error;
    }
};